export default __webpack_public_path__ + "static/media/ImageGroup.857ecb54.png";